import { render } from "./UnwrapPeercoin.vue?vue&type=template&id=455ede4c&scoped=true"
import script from "./UnwrapPeercoin.vue?vue&type=script&lang=js"
export * from "./UnwrapPeercoin.vue?vue&type=script&lang=js"

import "./UnwrapPeercoin.vue?vue&type=style&index=0&id=455ede4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-455ede4c"

export default script